import {
  Button,
  EButtonColorVariant,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { useIntl } from 'react-intl';

import mediaUrl from '@/assets/referral/join-heading.jpg';
import MaxWidth from '@/components/common/layout/MaxWidth';
import { triggerLoginModal } from '@/utility/triggerLoginModal';

export const JoinHeading = () => {
  const intl = useIntl();

  return (
    <MaxWidth className="py-10 m-auto md:grid md:grid-cols-12">
      <div className="flex flex-col text-center gap-6 md:col-span-5 md:text-left">
        <div className="flex flex-col gap-2">
          <Text variant={ETextStyleVariant.LargeBold}>
            {intl.formatMessage({
              defaultMessage: 'Rent with a group and save on your trip',
              id: 'dA/xyx',
            })}
          </Text>

          <Heading variant={EHeadingStyleVariant.H3}>
            {intl.formatMessage(
              { defaultMessage: `Give $50, get $75. {br} It's a win-win!`, id: 'ttBX0/' },
              { br: <br /> },
            )}
          </Heading>
        </div>

        <Text variant={ETextStyleVariant.LargeRegular} className="text-gray-700">
          {intl.formatMessage({
            defaultMessage:
              'Help your friends save on their next trip while earning travel credits for your own. Group trips have never been easier. Everyone gets to #liveoutdoorsy.',
            id: 'o8KOCc',
          })}
        </Text>

        <div className="flex flex-col gap-2">
          <div>
            <Button
              onClick={() => triggerLoginModal(0)}
              label={intl.formatMessage({
                defaultMessage: 'Log in or sign up to start referring',
                id: 'sE8/D1',
              })}
              variant={EButtonColorVariant.Primary}
              className="w-full md:w-auto"
            />
          </div>
        </div>
      </div>

      <div className="items-center hidden pl-4 md:flex md:col-span-7">
        <Image
          alt="Join and save on your trip"
          src={mediaUrl}
          width={594}
          height={354}
          role="presentation"
          loading="lazy"
        />
      </div>
    </MaxWidth>
  );
};
